// Simple 2-tone chime using WebAudio API — no external audio file needed.
// Kept inside the module so the AudioContext is created lazily (avoids Chrome autoplay warnings).
import { logWarn } from "@/lib/logger";

let ctx = null;

function getCtx() {
  if (ctx) return ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    return ctx;
  } catch { return null; }
}

/** Play a subtle two-note chime. Safe to call from click / async handlers. */
export function playChime() {
  const audio = getCtx();
  if (!audio) return;
  // Resume if the tab was backgrounded
  if (audio.state === "suspended") { try { audio.resume(); } catch (err) { logWarn("audio resume:", err); } }

  const now = audio.currentTime;
  const notes = [
    { freq: 880, start: 0, dur: 0.18 },       // A5
    { freq: 1174.66, start: 0.14, dur: 0.28 }, // D6
  ];
  const master = audio.createGain();
  master.gain.value = 0.22; // gentle volume
  master.connect(audio.destination);

  notes.forEach(({ freq, start, dur }) => {
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    // Soft attack + release envelope so it doesn't click
    gain.gain.setValueAtTime(0.0001, now + start);
    gain.gain.exponentialRampToValueAtTime(1.0, now + start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
    osc.connect(gain).connect(master);
    osc.start(now + start);
    osc.stop(now + start + dur + 0.02);
  });
}
